export default __webpack_public_path__ + "static/media/transport-large.7de56a19.svg";